/*
 * Public API Surface of angularx-qrcode
 */

export { QRCodeComponent } from "./lib/angularx-qrcode.component"
export * from "./lib/types"
